import { z } from "zod";

const iCafeItemSchema = z.object({
  iCafeId: z.string().optional(),
  playncAccountId: z.string(),
  pcCafeAccount: z.string(),
  isPrimary: z.boolean(),
  companyName: z.string(),
  companyFullName: z.string().optional(),
  companyStateCode: z.number(),
  franchiseCode: z.number().optional(),
  registeredAt: z.string(),
  updatedAt: z.string(),
  sort: z.number(),
});

export const iCafeListSchema = z.array(iCafeItemSchema);

export type ICafeListType = z.infer<typeof iCafeListSchema>;
